export const ANNOTATE_PRELOAD_COUNT = 5;

export function protectedAssetUrl(apiHost, assetId) {
  return `${apiHost}/protected/asset/${assetId}`;
}

export function protectedAssetUrlWithToken(url, token) {
  if (!token) {
    return url;
  }
  return `${url}?token=${encodeURIComponent(token)}`;
}

export function preloadImage(url, token) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error('Image preload failed'));
    img.src = protectedAssetUrlWithToken(url, token);
  });
}

export function mapAnnotationsFromNextResult(result, AnnotationCtor) {
  let annotations = Array.isArray(result.annotations) ? result.annotations : [];
  let i = 0;
  const colors = Array.isArray(result.colors) ? result.colors : [];
  return annotations.map((annotation) => {
    const id = annotation.id;
    let color = colors[i];
    i += 1;
    let type = 'box';
    if (annotation.color) {
      color = annotation.color.split(',');
    }
    if (annotation.type === 2) {
      type = 'point';
    }
    const conf = annotation.conf != null && annotation.conf !== '' ? annotation.conf : '1';
    return new AnnotationCtor(id, type, annotation.coords, conf, annotation.label, color);
  });
}

export function buildAssetStateFromNextResult(result, apiHost, AnnotationCtor) {
  const asset = result.asset;
  const annotations = mapAnnotationsFromNextResult(result, AnnotationCtor);
  return {
    asset_id: asset.id,
    asset_url: protectedAssetUrl(apiHost, asset.id),
    meta: asset.meta,
    original_category: asset.original_category,
    annotation_suggestions: asset.annotation_suggestions || [],
    suggestion_match_logs: asset.suggestion_match_logs || [],
    asset_messages: asset.asset_messages || result.asset_messages || [],
    annotations,
    initial_annotations: JSON.parse(JSON.stringify(annotations)),
  };
}

export function isExcludedAssetId(assetId, excludeIds) {
  return new Set(excludeIds.filter(Boolean)).has(assetId);
}
